"use strict";
// @ts-ignore
try {
    self['workbox:expiration:7.4.0'] && _();
}
catch (e) { }
